import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the closing day report view.
 * @extends JetView
 */
export default class tableclosingDayReportView extends JetView {
    /**
     * Configures the view layout and data.
     * @returns {Object} Configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const data = [
            // Sample data for the report
            {
                Date: '2019-05-28',
                BetShop: 'Mundo Slot',
                User: 'usuario 1',
                StartTime: '23:59:59',
                ClosingTime: '23:59:59',
            },
            {
                Date: '2019-05-28',
                BetShop: 'Mundo Slot',
                User: 'usuario 2',
                StartTime: '23:59:59',
                ClosingTime: '23:59:59',
            },
            {
                Date: '2019-05-27',
                BetShop: 'Punto V 3',
                User: 'usuario 3',
                StartTime: '23:59:59',
                ClosingTime: '23:59:59',
            },
        ];
        // Extending the summTreeColumn filter for custom summation behavior
        webix.ui.datafilter.summTreeColumn = webix.extend(
            {
                refresh: function (master, node, value) {
                    var result = 0; // Variable to hold the summation result
                    var resultFormat = 0; // Variable for formatted result
                    master.data.each(function (obj) {
                        // Iterating through data
                        if (obj.$level == 1) result += obj[value.columnId]; // Summing values at level 1
                    });
                    // Formatting the result based on column type
                    if (value.columnId === 'CantidadTickets') {
                        resultFormat = webix.i18n.intFormat(result);
                    } else {
                        resultFormat = webix.i18n.priceFormat(result);
                    }
                    node.firstChild.innerHTML = resultFormat; // Updating the node with formatted result
                },
            },
            webix.ui.datafilter.summColumn, // Extending from summColumn
        );
        return {
            // Returning the configuration for the treetable
            view: 'treetable',
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            id: 'ClosingDay', // Unique identifier for the view
            scrollY: screen.width < 820 ? false : true, // Conditional vertical scrolling
            height: screen.width < 820 ? 490 : 0, // Conditional height based on screen width
            bready: function () {
                // Function to open all rows
                this.openAll();
            },
            columns: [
                // Column definitions for the treetable
                {
                    id: 'User',
                    header: _('Usuario'), // Localized header
                    width: 350,
                    template: function (obj, common) {
                        // Custom template for User column
                        if (obj.$group) return common.treetable(obj, common) + obj.value; // Grouped item display
                        return obj.User; // Regular item display
                    },
                },
                { id: 'StartTime', header: _('Hora Inicio'), width: 120 }, // StartTime column
                { id: 'ClosingTime', header: _('Hora Cierre'), width: 120 }, // ClosingTime column
            ],
            autowidth: false, // Disable automatic width adjustment
            math: true, // Enable mathematical operations
            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
            pager: 'pagerA', // Pager ID for pagination
            data: data, // Initial data for the table
            url: devConfig.geturlApi() + 'Accounting/GetClosingDayReport', // API endpoint for data fetching
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid instance to initialize.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        var url = grid.data.url; // URL for data loading
        // Event handler for after data load
        grid.attachEvent('onAfterLoad', function () {
            $$('ClosingDay').data.group({
                // Grouping data by BetShop
                by: 'BetShop',
                map: {
                    Date: ['Date'],
                    BetShop: ['BetShop'],
                },
            });
            $$('ClosingDay').data.group({
                // Grouping data by Date
                by: 'Date',
                map: {
                    BetShop: ['BetShop'],
                },
            });
        });
        // Event handler for filtering data
        this.on(this.app, 'closingDay:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Query string for filters
            for (var i = 0; i < object.length; i++) {
                // Iterating through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        // Handling date range filter
                        var date = object[i][1].split(' - ');
                        console.log(date); // Logging date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Adding dateFrom to query
                        string1 = string1 + '&dateTo=' + date[1]; // Adding dateTo to query
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Adding other filters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handling object type filters
                        var object2 = Object.entries(object[i][1]);
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    // Handling start date
                                    var d = new Date(object2[j][1]);
                                    var dateFrom = // Formatting start date
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Adding formatted start date to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handling end date
                                        var d = new Date(object2[j][1]);
                                        var dateTo = // Formatting end date
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Adding formatted end date to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clearing the grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Loading data with filters
        });
        // Event handler for item click
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Getting the clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Triggering user ID event
        });
        // Event handler for player selection
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                // Loading data based on selected player
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id,
            );
        });
    }
}

// FILE DOCUMENTED
